import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=4b357852&scoped=true&"
import script from "./ProfileDetails.vue?vue&type=script&lang=js&"
export * from "./ProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=4b357852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b357852",
  null
  
)

export default component.exports